import { ChangeEvent, useCallback } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useMST1030_R01Store, { defaultMST1030_R01Filter } from "./Store_MST1030_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { getItemPopupList } from "src/apis/itemApi";
import { CodeSearchModalProps } from "src/types/code-search";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {
    fetchData?: () => Promise<any>;
}

export const SearchSection_MST1030_R01 = ({ fetchData }: Props) => {
    const { MST1030_R01Filter, setMST1030_R01Filter } = useMST1030_R01Store();
    const { itemGroupList, itemAccountList } = useCommonCodeStore();
    const { selectedItemInfo, setSelectedItemInfo } = useMST1030_R01Store();
    const { setCodeSearchModalProps } = useUiuxStore();

	const searchTextHandleFoucsId = 'searchText_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'searchText',
			category: '품목코드',
			focusId: searchTextHandleFoucsId,
			responseMapping: {
				itemCd: 'searchText',
				itemNm: 'searchTextNm',
			},
			extraFilter: () => ({
				searchText: MST1030_R01Filter.searchText || '',
				searchTextNm: MST1030_R01Filter.searchTextNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST1030_R01Filter,
		setEditData: setMST1030_R01Filter,
		defaultData: defaultMST1030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST1030_R01_search'
	});	

    return (
        <SearchSectionForm>
            <SearchDropDownForm
                label="품목그룹"
                value={MST1030_R01Filter.itemGroup}
                optionList={itemGroupList}
                onChangeItem={(selectedItem) => setMST1030_R01Filter({ itemGroup: selectedItem?.minorCd || ''})}
            />
            <SearchDropDownForm
                label="품목계정"
                value={MST1030_R01Filter.itemAccount}
                optionList={itemAccountList}
                onChangeItem={(selectedItem) => setMST1030_R01Filter({ itemAccount: selectedItem?.minorCd || ''})}
            />
            <SearchCodeModalForm
                label="품목코드"
                value={MST1030_R01Filter.searchText}
                valueLabel={MST1030_R01Filter.searchTextNm || ''}
                onChange={getFieldHandlers('searchText').onChange}
                onDoubleClick={getFieldHandlers('searchText').onDoubleClick} 
                onKeyDown={getFieldHandlers('searchText').onEnterKeyDown}
            />
        </SearchSectionForm>
    );
}; 